module.exports = __webpack_public_path__ + "fae7176f2a3f70ebe96e9292ecdb8fb4.pdf";